<template>
	<div class="hotelUse">
		<div class="column">
			<div class="columnText2" style="margin-right: 0.1rem;">
				酒店预定号
			</div>
			<el-input :disabled="disabled" size="small" v-model="datas.useNumber" class="columnText3" placeholder-class="placeholder"
				style="flex: 1;" placeholder="请输入酒店预定号（如有）" type="text"></el-input>
		</div>
		<div class="column">
			<div class="columnText4" style="margin-right: 0.1rem;">
				抵达酒店后
			</div>
			<div class="columnText3" style="flex: 1;">{{ datas.useMethod ? datas.useMethod : '未填写' }}</div>
		</div>
		<div class="column">
			<div class="columnText4" style="margin-right: 0.1rem;">
				使用说明文字描述
			</div>
			<el-input :disabled="disabled" size="small" v-model="datas.useExplain" class="columnText3" placeholder-class="placeholder"
				style="flex: 1;" placeholder="请输入使用说明文字描述" type="text"></el-input>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		datas: {
			type: Object,
			default: {}
		},
		disabled:{
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			init: this.datas,
			rangeList: ['用您的预定时提供的证件即可入驻', '用您的预定时提供的证件以及voucher(预定凭证)即可入驻']
		}
	},
	methods: {

	},
}
</script>

<style>
.placeholder {
	color: rgba(16, 16, 16, 0.65);
	font-size: 20rpx;
	font-family: PingFangSC-light;
}
</style>
<style lang="scss" scoped>
.hotelUse {
	border-radius: 0.05rem;
	background-color: rgba(250, 250, 250, 1);
	padding: 0 0.1rem;

	.column {
		height: 0.4rem;
		border-top: 1px dotted #E9E9E9;
		display: flex;
		align-items: center;
		justify-content: space-between;

		&:nth-child(1) {
			border-top: none;
			height: 70rpx;
		}

		.columnText2 {
			color: rgba(149, 144, 144, 1);
			font-size: 0.15rem;
		}

		.columnText3 {
			color: #000000;
			font-size: 0.15rem;
		}

		.columnText4 {
			color: rgba(230, 74, 25, 1);
			font-size: 0.15rem;
		}

		.columnText1 {
			color: #000000;
			font-size: 0.15rem;
			text-align: center;
		}
	}
}
</style>
